import axios from "../utils/axios.js"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { setIsLoggedIn, setUser, setTasks, setEdits } from '../redux/slice.js'

import '../styles/main.css'
import { useEffect, useState } from "react"
import classNames from "classnames"
import Task from "../components/Task/Task.jsx"
import NewTaskPopup from "../components/Popups/NewTaskPopup.jsx"
import Folder from "../components/Folder/Folder.jsx"
import FM_File from "../components/FM_File/FM_File.jsx"
import NewElementPopup from "../components/Popups/NewElementPopup.jsx"

export default () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isLoggedIn = useSelector(state => state.user.isLoggedIn)
  const tasks = useSelector(state => state.user.tasks)
  const user = useSelector(state => state.user.user)

  const edits = useSelector(state => state.user.edits)

  const [newTaskPopup, setNewTaskPopup] = useState(false)
  const [newElementPopup, setNewElementPopup] = useState(false)
  const [renderType, setRenderType] = useState(0)
  const [activeFilter, setActiveFilter] = useState(1)

  const [curFolder, setCurFolder] = useState({})

  if (!isLoggedIn) {
    axios
      .get("/auth/me")
      .then((response) => {
          dispatch(setUser(response.data.user))
          dispatch(setIsLoggedIn(true))
        })
      .catch((err) => {
          navigate('/login')
      })    
  }

  useEffect(() => {
    axios
    .get("/get_group_folder")
    .then((response) => {
        setCurFolder(response.data.folder)
      })
    .catch((err) => {})
  }, [])

  const getTasks = () => {
    axios
      .get("/tasks/get_tasks")
      .then((response) => {
          dispatch(setTasks(response.data.tasks))
          dispatch(setEdits(response.data.edits))
        })
      .catch((err) => {})
  }

  const getFolder = (folder_id) => {
    axios
      .get(`/files/get_folder/${folder_id}`)
      .then(res => {
        setCurFolder(res.data.folder)
      })
      .catch(err => {})
  }

  const prepareTasks = (filter) => {
    if (filter === 0) {
      return [...tasks].sort((a, b) => b.deadline-a.deadline)
    } else if (filter === 1) {
      return [...tasks].filter(el => el.deadline > new Date().getTime()-24*60*60*1000).sort((a, b) => a.deadline-b.deadline)
    }
  }

  const [flag, setFlag] = useState(false)
  useEffect(() => {
    axios
      .get('/tasks/get_edits')
      .then((res) => {
        if (res.data.edits > edits) getTasks()
      })
      .catch(err => {})

    setTimeout(() => setFlag(!flag), 30000)
  }, [flag])

  // const numOfCompletedTasks = tasks.filter(el => el.isCompleted).length

  // const getGradient = (r1, g1, b1, r2, g2, b2, k) => {
  //   const r = r1 + (r2-r1)*k
  //   const g = g1 + (g2-g1)*k
  //   const b = b1 + (b2-b1)*k
  //   return `${r},${g},${b}`
  // }

  return (
    <>
      <NewTaskPopup isActive={newTaskPopup} setActive={setNewTaskPopup}/>
      <NewElementPopup isActive={newElementPopup} setActive={setNewElementPopup} curFolder={curFolder} getFolder={getFolder} />

      <div className="body_container">
          {/* <div className="main_menu">
            <div className="user_info_container">
              <div className="user_photo">
                <img src={user.photo_url} />
              </div>
              <div className="user_data">
                <div className="user_full_name">{user.last_name + " " + user.first_name}</div>
                <div className="user_tg_name">{"@" + user.username}</div>
              </div>
            </div>
            <div className="menu_data">
              <div className="tasks_count" style={{ 
                  borderColor: `rgb(${getGradient(255,68,35, 112,255,105, tasks.length? numOfCompletedTasks/tasks.length : 1)})`, 
                  backgroundColor: `rgba(${getGradient(255,68,35, 112,255,105, tasks.length? numOfCompletedTasks/tasks.length : 1)}, .4)` 
                }}>
                { numOfCompletedTasks + ' / ' + tasks.length }
              </div>

              <input type="text" className="task_search" placeholder="Поиск по заданиям"/>
            </div>
            <div className="settings_button">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M13.9838 2.54161C14.0711 2.71093 14.0928 2.92777 14.1361 3.36144C14.2182 4.1823 14.2593 4.59274 14.4311 4.81793C14.649 5.10358 15.0034 5.25038 15.3595 5.20248C15.6402 5.16472 15.9594 4.90352 16.5979 4.38113C16.9352 4.10515 17.1038 3.96716 17.2853 3.90918C17.5158 3.83555 17.7652 3.84798 17.9872 3.94419C18.162 4.01994 18.3161 4.17402 18.6243 4.4822L19.5178 5.37567C19.8259 5.68385 19.98 5.83794 20.0558 6.01275C20.152 6.23478 20.1644 6.48415 20.0908 6.71464C20.0328 6.89612 19.8948 7.06478 19.6188 7.4021C19.0964 8.0406 18.8352 8.35984 18.7975 8.64056C18.7496 8.99662 18.8964 9.35102 19.182 9.56893C19.4072 9.74072 19.8176 9.78176 20.6385 9.86385C21.0722 9.90722 21.2891 9.92891 21.4584 10.0162C21.6734 10.1272 21.841 10.3123 21.9299 10.5373C22 10.7145 22 10.9324 22 11.3682V12.6319C22 13.0676 22 13.2855 21.93 13.4626C21.841 13.6877 21.6734 13.8729 21.4583 13.9838C21.289 14.0711 21.0722 14.0928 20.6386 14.1361L20.6386 14.1361C19.818 14.2182 19.4077 14.2592 19.1825 14.4309C18.8967 14.6489 18.7499 15.0034 18.7979 15.3596C18.8357 15.6402 19.0968 15.9593 19.619 16.5976C19.8949 16.9348 20.0328 17.1034 20.0908 17.2848C20.1645 17.5154 20.152 17.7648 20.0558 17.9869C19.98 18.1617 19.826 18.3157 19.5179 18.6238L18.6243 19.5174C18.3162 19.8255 18.1621 19.9796 17.9873 20.0554C17.7652 20.1516 17.5159 20.164 17.2854 20.0904C17.1039 20.0324 16.9352 19.8944 16.5979 19.6184L16.5979 19.6184C15.9594 19.096 15.6402 18.8348 15.3595 18.7971C15.0034 18.7492 14.649 18.896 14.4311 19.1816C14.2593 19.4068 14.2183 19.8173 14.1362 20.6383C14.0928 21.0722 14.0711 21.2891 13.9837 21.4585C13.8728 21.6735 13.6877 21.8409 13.4628 21.9299C13.2856 22 13.0676 22 12.6316 22H11.3682C10.9324 22 10.7145 22 10.5373 21.9299C10.3123 21.841 10.1272 21.6734 10.0162 21.4584C9.92891 21.2891 9.90722 21.0722 9.86385 20.6385C9.78176 19.8176 9.74072 19.4072 9.56892 19.182C9.35101 18.8964 8.99663 18.7496 8.64057 18.7975C8.35985 18.8352 8.04059 19.0964 7.40208 19.6189L7.40206 19.6189C7.06473 19.8949 6.89607 20.0329 6.71458 20.0908C6.4841 20.1645 6.23474 20.152 6.01272 20.0558C5.8379 19.9801 5.6838 19.826 5.37561 19.5178L4.48217 18.6243C4.17398 18.3162 4.01988 18.1621 3.94414 17.9873C3.84794 17.7652 3.8355 17.5159 3.90913 17.2854C3.96711 17.1039 4.10511 16.9352 4.3811 16.5979C4.90351 15.9594 5.16471 15.6402 5.20247 15.3594C5.25037 15.0034 5.10357 14.649 4.81792 14.4311C4.59273 14.2593 4.1823 14.2182 3.36143 14.1361C2.92776 14.0928 2.71093 14.0711 2.54161 13.9838C2.32656 13.8728 2.15902 13.6877 2.07005 13.4627C2 13.2855 2 13.0676 2 12.6318V11.3683C2 10.9324 2 10.7144 2.07008 10.5372C2.15905 10.3123 2.32654 10.1272 2.54152 10.0163C2.71088 9.92891 2.92777 9.90722 3.36155 9.86384H3.36155H3.36156C4.18264 9.78173 4.59319 9.74068 4.81842 9.56881C5.10395 9.35092 5.2507 8.99664 5.20287 8.64066C5.16514 8.35987 4.90385 8.04052 4.38128 7.40182C4.10516 7.06435 3.96711 6.89561 3.90914 6.71405C3.83557 6.48364 3.848 6.23438 3.94413 6.01243C4.01988 5.83754 4.17403 5.68339 4.48233 5.37509L5.37565 4.48177L5.37566 4.48177C5.68385 4.17357 5.83795 4.01947 6.01277 3.94373C6.23478 3.84753 6.48414 3.8351 6.71463 3.90872C6.89612 3.9667 7.06481 4.10472 7.4022 4.38076C8.04061 4.9031 8.35982 5.16427 8.64044 5.20207C8.99661 5.25003 9.35113 5.10319 9.56907 4.81742C9.74077 4.59227 9.78181 4.18195 9.86387 3.36131C9.90722 2.92776 9.9289 2.71098 10.0162 2.5417C10.1271 2.32658 10.3123 2.15898 10.5374 2.07001C10.7145 2 10.9324 2 11.3681 2H12.6318C13.0676 2 13.2855 2 13.4627 2.07005C13.6877 2.15902 13.8728 2.32656 13.9838 2.54161ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"/>
              </svg>
            </div>
          </div> */}

          <div className="render_type">
            <div className={classNames("render_type__item", {active: renderType===0})} onClick={() => setRenderType(0)}>Все задания</div>
            <div className="render_type__item">|</div>
            <div className={classNames("render_type__item", {active: renderType===1})} onClick={() => setRenderType(1)}>Файлы</div>
          </div>

          {
            renderType === 0 ?
              <div className="all_tasks_page">
                <div className="all_tasks_menu">
                  <div className="tasks_filters">
                    <div className={classNames("filter_item", {active: activeFilter === 0})} onClick={() => setActiveFilter(0)}>
                      Все
                    </div>
                    <div className={classNames("filter_item", {active: activeFilter === 1})} onClick={() => setActiveFilter(1)}>
                      Предстоящие
                    </div>
                  </div>
                
                  <button className="create_new_task_button" onClick={() => setNewTaskPopup(true)}>
                    <div className="create_new_task_text">Создать</div>
                    <div className="create_new_task_icon">
                      <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.5 3.75L7.5 11.25" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M11.25 7.5L3.75 7.5" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </div>
                  </button>
                
                </div>
                {
                  tasks.length === 0 ?
                  <div className="nonTasksLabel">Заданий пока нет...</div>
                  :
                  <></>
                }
                <div className="tasks__container">
                  { prepareTasks(activeFilter).map(el => {
                    return <Task task={el} key={el._id}/>
                  })}
                </div>
              </div>
              :
              <div style={{textAlign: "center", color: "var(--tg-theme-text-color)", fontSize: "18px", marginTop:"20px"}} className="file_manager_page">
                <div className="file_manager__header">
                  <div className="file_manager_side">
                    <div className="goto_parent_folder__button" onClick={ () => {
                      if (!!curFolder.parent) {
                        getFolder(curFolder.parent)
                      }
                    } } >
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 6L4 12M4 12L10 18M4 12H19" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <div className="cur_folder_name"> {curFolder.name} </div>
                  </div>
                  { user.permissions > 1 ?
                    <button className="add_folder__button" onClick={() => setNewElementPopup(true)}>
                      <div className="add_folder__text">Добавить</div>
                        <div className="add_folder__icon">
                        <div className="create_new_task_icon">
                          <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 3.75L7.5 11.25" strokeWidth="2" strokeLinecap="round"/>
                            <path d="M11.25 7.5L3.75 7.5" strokeWidth="2" strokeLinecap="round"/>
                          </svg>
                        </div>
                      </div>
                    </button>
                    :
                    <></>  
                  }
                </div>

                { 
                  curFolder?.folders?.length === 0 && curFolder?.files?.length === 0 ?
                    <div className="file_manager_empty_text">В папке "{curFolder.name}" пока нет файлов...</div>
                  :
                  <div className="file_manager__container">
                  {
                    curFolder?.folders?.sort((a, b) => a.name.localeCompare(b.name)).map(el => {
                      return <Folder el={el} key={el._id} curFolder={curFolder} getFolder={getFolder} />
                    })
                  }
                  {
                    curFolder?.files?.sort((a, b) => a.name.localeCompare(b.name)).map(el => {
                      return <FM_File key={el._id} el={el} curFolder={curFolder} getFolder={getFolder} />
                    })
                  }
                </div>
                }
              </div>
          }

      </div>
    </>
  )
}